import React, { useState } from 'react'
import ErrorPage from './ErrorPage'
import Forbidden403 from './Forbidden403'
import NoContent from './NoContent204'
import Unauthorized401 from './Unauthorized401'

export const ErrorContext = React.createContext({ error: null, setError: () => { } });

const ErrorProvider = ({ children }) => {
    const [error, setError] = useState(null);
    let errorPage;
    const status = error ? error.status : null;
    switch (status) {
        case 500:
            errorPage = <ErrorPage codeNumber={500} label='błąd serwera' />
            break;
        case 204:
            errorPage = <NoContent />
            break;
        case 403:
            errorPage = <Forbidden403 />
            break;
        case 401:
            errorPage = <Unauthorized401 />
            break;
        default:
            errorPage = null
    }
    return <ErrorContext.Provider value={{ error, setError }}>
        {error ? errorPage : children}
    </ErrorContext.Provider>
}

export default ErrorProvider